module.exports = __webpack_public_path__ + "img/grok-ico.903dbf30.svg";